import React from 'react';
import { equals } from 'ramda';
import clsx from 'clsx';
import PropTypes from 'prop-types';

import useStyles from './useStyles';

const Tag = props => {
  const { className, color, children } = props;
  const classes = useStyles();

  const isColor = clr => equals(clr, color);

  return (
    <div
      className={clsx(classes.container, className, {
        [classes.green]: isColor('green'),
        [classes.red]: isColor('red'),
        [classes.blue]: isColor('blue'),
      })}
    >
      {children}
    </div>
  );
};

Tag.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  color: PropTypes.string,
};

Tag.defaultProps = {
  color: 'green',
  className: '',
};

export default Tag;



// WEBPACK FOOTER //
// ./src/sharedComponents/Tag/Tag.js